import styled, { css } from 'styled-components';
import { getWindow } from '../../../utils/getWindow';
import { Box, BoxProps } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import {
    BUTTON_INDENTION,
    DEFAULT_DESCRIPTION_HEIGHT,
    RETURN_TEXT_INDENTION,
    REVERSE_BUTTON_INDENTION,
    TEXT_INDENTION,
} from './constants';

// PostCard

export const Root = styled(Box).attrs((props) => ({
    ...props,
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    as: 'article',
}))`
    -webkit-user-select: none;
    user-select: none;
    transform: translateZ(0px);
`;

export const Header = styled(Flex).attrs((props) => ({
    ...props,
    as: 'header',
    direction: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'absolute',
    top: 0,
    left: 0,
    p: 2,
    width: '100%',
    zIndex: 5,
    spacing: 1,
}))``;

export const Content = styled(Flex)
    .withConfig({ displayName: 'Content' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        direction: 'column',
        justifyContent: 'flex-end',
        px: 1,
        pb: 2,
        pt: 7.5,
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: 2,
    }))``;

export const Shadow = styled(Box)
    .withConfig({ displayName: 'Shadow' })
    .attrs((props) => ({
        ...props,
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 1,
        pointerEvents: 'none',
        background: 'rgba(0, 0, 0, 0.70)',
        transition: '200ms linear opacity',
        cursor: 'pointer',
    }))``;

// AnimateFooter

interface DescriptionProps extends BoxProps {
    type: 'short' | 'normal';
    isExpanded: boolean;
}

export const Description = styled(Typography).attrs((props) => ({
    ...props,
    variant: 'body2',
    color: '#FFFFFF',
    textShadow: '0px 1px 2px rgba(0, 0, 0, 0.10)',
    textDecoration: 'none',
}))<DescriptionProps>`
    ${({ type, isExpanded }: DescriptionProps) =>
        type === 'short'
            ? css`
                  white-space: nowrap;
                  overflow: hidden;
                  position: absolute;
                  text-overflow: ellipsis;
                  width: calc(100% - 9.5rem);
                  opacity: ${isExpanded ? 0 : 1};
              `
            : css`
                  width: 100%;
                  overflow-y: scroll;
                  opacity: ${isExpanded ? 1 : 0};
                  scrollbar-color: ${isExpanded
                      ? 'rgba(255, 255, 255, 0.65) transparent'
                      : 'transparent transparent'};
                  scrollbar-width: thin;
              `}

    ${() => css`padding-right: 5px;,`}
`;

interface ButtonBoxProps {
    isExpanded: boolean;
    descriptionHeight: number;
}

export const ButtonBox = styled(Box).attrs((props) => ({
    ...props,
    position: 'absolute',
    bottom: '0.5em',
    right: '1.5%',
}))<ButtonBoxProps>`
    ${({ isExpanded, descriptionHeight }: ButtonBoxProps) =>
        isExpanded
            ? css`
                  width: 97%;
                  transform: translateY(${BUTTON_INDENTION}px);
              `
            : css`
                  width: 8rem;
                  transform: translateY(${REVERSE_BUTTON_INDENTION - descriptionHeight}px);
              `}
`;

export const Text = styled(Typography).attrs((props) => ({
    ...props,
    variant: 'body3',
    color: '#FFFFFF',
    textShadow: '0px 1px 2px rgba(0, 0, 0, 0.10)',
    textDecoration: 'none',
}))``;

interface BusinessNameProps {
    isShort: boolean;
    businessNameWidth: number | undefined;
}

export const BusinessName = styled(Text).attrs((props) => ({
    ...props,
    weight: 'bold',
    willChange: 'max-width',
    overflow: 'hidden',
}))<BusinessNameProps>`
    ${({ isShort, businessNameWidth = getWindow()?.innerWidth }: BusinessNameProps) =>
        isShort
            ? css`
                  max-width: 0;
              `
            : css`
                  max-width: ${businessNameWidth}px;
              `}
`;

interface FooterProps {
    isExpanded: boolean;
    descriptionHeight: number;
}

export const Footer = styled(Flex).attrs((props) => ({
    ...props,
    as: 'footer',
    direction: 'row',
    alignItems: 'center',
    spacing: 1,
    mt: 1,
    width: '100%',
    justifyContent: 'space-between',
    pointerEvents: 'auto',
    px: 1,
}))<FooterProps>`
    ${({ isExpanded, descriptionHeight }: FooterProps) =>
        isExpanded
            ? css`
                  transform: translateY(-${TEXT_INDENTION}px);
              `
            : css`
                  transform: translateY(
                      ${(descriptionHeight || DEFAULT_DESCRIPTION_HEIGHT) - RETURN_TEXT_INDENTION}px
                  );
              `}
`;
